import React, { useCallback, useState, useRef, useMemo, useEffect } from 'react';
import { Grid, Button, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { localeSelector } from 'src/selector/app';
import { JoinClassName } from 'src/utils/utils';
import Image from 'next/image';
import CommonGetDemoTopSection from '../CommonGetDemoTopSection';
import AutoPlayer from 'src/components/AutoPlayer';
import UnoptimizedImage from 'src/components/UnoptimizedImage';

const { useBreakpoint } = Grid;

const ProductAdvantages = ({ title, description, features }) => {
  const screens = useBreakpoint();
  return (
    <React.Fragment>
      <div
        className={JoinClassName(
          indexStyles.productAdvantagesSection,
          screens.xs ? indexStyles.forMobile : '',
          screens.md ? indexStyles.forMDDevice : '', //768
          screens.sm && !screens.md ? indexStyles.forSMDevice : '' //576
        )}
      >
        <Row align={'middle'} justify={'center'} wrap={false}>
          <Col xs={23} md={22} lg={21} xl={21} xxl={17}>
            <div className={JoinClassName(indexStyles.productAdvantageHeader)}>
              <h2 className={JoinClassName(indexStyles.title_h2)}>{title}</h2>
              <p className={JoinClassName(indexStyles.subdesc)}>{description}</p>
            </div>
          </Col>
        </Row>
        <Row align={'top'} justify={'center'} wrap={true} gutter={[20, 0]}>
          {features.map(({ image, imageAlt, title, description }, index) => {
            return (
              <Col xs={21} sm={11} md={5} lg={5} key={index}>
                <div className={JoinClassName(indexStyles.productAdvantagePoint)}>
                  <div className={JoinClassName(indexStyles.imgContainer)}>
                    <UnoptimizedImage src={image} layout="fill" objectFit="contain" alt={imageAlt} />
                  </div>
                  {title && <h3 className={JoinClassName(indexStyles.title_h2)}>{title}</h3>}
                  <p className={JoinClassName(indexStyles.subdesc)}>{description}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default ProductAdvantages;
